import { useState } from 'react';
import FilterSheet from './FilterSheet';
import Icon from './Icon';

// The options list itself, split out so a page can embed it inside a sheet it
// already owns (SuppliersFilterBar folds sort into the same sheet as its other
// filters, one trigger instead of two) instead of getting MobileSort's own
// trigger button + separate sheet. Every other consumer keeps using the
// default export below unchanged.
//
// `options`: [{ key, label }] — keep to the 2-4 sorts that answer real
// questions, not one per former column. `sort`: { field, dir } from
// useSortable; `onChange(field|null, dir|null)` -> setSortTo.
export function SortOptions({ options, sort, onChange }) {
  const active = options.find(o => o.key === sort.field);
  return (
    <div className="msf-inline">
      {options.map(o => {
        const isActive = sort.field === o.key;
        return (
          <button
            key={o.key}
            type="button"
            className={`msf-inline-header${isActive ? ' is-active' : ''}`}
            onClick={() => onChange(o.key, isActive && sort.dir === 'asc' ? 'desc' : 'asc')}
          >
            <span className="msf-inline-label">{o.label}</span>
            <span className="msf-inline-summary">
              {isActive && (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                  <Icon name={sort.dir === 'desc' ? 'arrow-down' : 'arrow-up'} size={13} />
                  {sort.dir === 'desc' ? 'יורד' : 'עולה'}
                </span>
              )}
            </span>
          </button>
        );
      })}
      <button
        type="button"
        className="msf-inline-header"
        onClick={() => onChange(null, null)}
      >
        <span className="msf-inline-label" style={{ color: 'var(--ink-muted)', fontWeight: 400 }}>
          ברירת מחדל
        </span>
        <span className="msf-inline-summary">{!active && <Icon name="check" size={14} />}</span>
      </button>
    </div>
  );
}

// Mobile sort control — the list rows have no column headers, so this is
// the sorting affordance: a sort pill (shows the active sort + direction) that
// opens a FilterSheet of options. Tapping an option applies instantly
// (same instant-apply language as the filters); tapping the active option
// flips its direction; "ברירת מחדל" restores the unsorted server order.
export default function MobileSort({ options, sort, onChange }) {
  const [open, setOpen] = useState(false);
  const active = options.find(o => o.key === sort.field);

  return (
    <>
      <button
        type="button"
        className={`docs-filter-control filter-sheet-trigger${active ? ' is-active' : ''}`}
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label="מיון"
      >
        <Icon name="sort" size={16} />
        {/* Direction arrow only — the field NAME is deliberately not shown.
            It costs 40-70px of a 375px row (enough to squeeze the search box
            down to a bare magnifier), and it is redundant next to a list the
            user is already looking at. The full state is one tap away in the
            sheet, and the pill still reads as active via .is-active. */}
        {active && (
          <Icon name={sort.dir === 'desc' ? 'arrow-down' : 'arrow-up'} size={13} />
        )}
      </button>

      <FilterSheet open={open} onClose={() => setOpen(false)} title="מיון">
        <SortOptions options={options} sort={sort} onChange={onChange} />
      </FilterSheet>
    </>
  );
}
